<template>
  <v-card class="ma-3">
    <v-card-title>
      <h2>{{ title }}</h2>
    </v-card-title>
    <v-card-title>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-btn color="primary" @click="addNew">{{ $t('Add new') }}</v-btn>
        </v-flex>
        <v-flex xs12 md9>
          <v-layout row>
            <v-flex shrink v-if="profile === 'consultant'">
              <v-select
                class="pr-2"
                v-model="consultantStatus"
                :items="[
                  { text: 'Todos', value: null },
                  { text: 'Activos', value: true },
                  { text: 'Inactivos', value: false },
                ]"
                item-text="text"
                item-value="value"
                label="Estado"
              ></v-select>
            </v-flex>
            <v-flex grow>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('Search')"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-dialog v-if="!loading" v-model="formDialog" max-width="650px">
      <customer-data-form
        v-if="profile == 'customer' && configLoaded"
        :config="config"
        :edit-index="editedIndex"
        :edit-item="editedItem"
        @closeDialog="closeDialog"
        @profileSaved="profileSaved"
      ></customer-data-form>
      <consultant-form
        :key="consultantFormKey"
        v-if="profile == 'consultant' && !loading"
        :edit-index="editedIndex"
        :edit-item="editedItem"
        @closeDialog="closeDialog"
        @profileSaved="profileSaved"
      ></consultant-form>

      <!-- <slot name="form" v-if="formDialog" :editItem="editedItem" :form-dialog="formDialog"></slot> -->
    </v-dialog>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :search="search"
      :rows-per-page-items="[10, 20, 30, 50, 100]"
    >
      <template slot="items" slot-scope="props">
        <td v-for="col of headers" :key="col.value">
          <template v-if="!Array.isArray(props.item[col.value])">
            <template v-if="col.value == 'action'">
              <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
              <template v-if="userIsSuperAdmin && profile === 'consultant'">
                <v-icon small @click="deleteItem(props.item)">delete</v-icon>
              </template>
              <template v-else-if="profile !== 'consultant'">
                <v-icon small @click="deleteItem(props.item)">delete</v-icon>
              </template>
            </template>
            <template v-else>
              {{ props.item[col.value] }}
            </template>
          </template>
          <template v-if="Array.isArray(props.item[col.value])">
            <template v-for="ob of props.item[col.value]">
              {{ ob }} &nbsp;
            </template>
          </template>
        </td>
      </template>
      <template slot="no-data">
        <v-btn color="primary" @click="initialize">{{ $t('Reset') }}</v-btn>
      </template>
    </v-data-table>
    <v-layout row justify-center>
      <v-dialog v-model="showDeleteProfileModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Eliminar') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2 v-if="profile === 'consultant'">
                    ¿Estás seguro de eliminar el asesor seleccionado?
                  </h2>
                  <h2 v-else>
                    ¿Estás seguro de eliminar el cliente seleccionado?
                  </h2>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click="
                showDeleteProfileModal = false;
                selectedProfileId = null;
              "
            >
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="deleteProfile()">
              {{ $t('Eliminar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-card>
</template>

<script>
import ProfileAPI from '@/services/api/profile.js';
import ApiCtrl from '../../../../../services/api/abstract/abstract-api.js';
import CustomerModel from '../../models/customer.js';
import ConsultantModel from '../../models/consultant.js';
import ConsultantForm from './ConsultantForm.vue';
import CustomerDataForm from './CustomerDataForm.vue';
export default {
  components: {
    ConsultantForm,
    CustomerDataForm,
  },
  props: ['title', 'profile'],
  data() {
    return {
      search: '',
      loading: true,
      items: [],
      formDialog: false,
      editedItem: {},
      editedIndex: null,
      config: {},
      configLoaded: false,
      consultantFormKey: 0,
      headers: [],
      consultantStatus: null,
      showDeleteProfileModal: false,
      selectedProfileId: null,
    };
  },

  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loading = true;

      this.editedItem = this.getEmptyProfileModel();

      const config = {
        params: {
          active: this.profile === 'consultant' ? this.consultantStatus : null,
        },
      };
      ProfileAPI.getProfiles(this.profile, config).then(response => {
        this.items = response.data.data;

        this.structure = response.data.structure;
        this.headers = response.data.dataTable.headers;
        this.loading = false;
        this.getConfig();
      });
    },

    getConfig() {
      this.configLoaded = false;
      ApiCtrl.get('/config/fiscaldata').then(res => {
        console.log({ config: res });
        this.config = res.data.data;
        this.configLoaded = true;
      });
    },

    getEmptyProfileModel() {
      switch (this.profile) {
        case 'consultant':
          return ConsultantModel.ConsultantModel();

        case 'customer':
          return CustomerModel.CustomerModel();

        default:
          break;
      }
    },
    editItem(item) {
      console.log({ EDIT_ITEM: item });
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // this.$emit('editItem', this.editedItem);
      this.consultantFormKey = this.consultantFormKey + 1;
      this.formDialog = true;
    },

    addNew() {
      this.editedIndex = null;
      this.editedItem = this.getEmptyProfileModel();
      this.formDialog = true;
    },

    deleteItem(item) {
      this.selectedProfileId = item.id;
      this.showDeleteProfileModal = true;
    },
    deleteProfile() {
      ProfileAPI.deleteProfile(this.profile, this.selectedProfileId).then(res => {
        console.log(res);
        this.initialize();
      });
      this.showDeleteProfileModal = false;
    },
    profileSaved(data) {
      // if(data.index) {
      //     this.items.splice(data.index, 1, data.profile);
      // } else {
      //     this.items.push(data.profile);
      // }
      this.initialize();
      this.formDialog = false;
    },
    closeDialog(closeDialog) {
      if (closeDialog) {
        this.formDialog = false;
        this.editedItem = this.getEmptyProfileModel();
      }
    },
  },
  computed: {
    userIsSuperAdmin() {
      const userRoleNames = this.$store.getters.userRoleNames;
      return userRoleNames.includes('superadmin');
    },
  },
  watch: {
    consultantStatus: {
      handler: function(val, oldVal) {
        this.initialize();
      },
    },
  },
};
</script>
